<template>
  <div class="container" :class="{ error }">
    <wrap-container class="grid-container grid-container--6-6">
      <div class="item col1">
        <div class="input-container">
          <input
            type="radio"
            :name="'option-' + $parent._uid"
            :id="'option-particular-' + $parent._uid"
            value="particular"
            @input="$emit('input', $event.target.value)"
            @blur="onBlur('modificar domicilio', 'particular')"
            :checked="!otroDomicilio"
            :data-obfuscate="quantumObfuscate"
          />
          <label
            :for="'option-particular-' + $parent._uid"
            :data-obfuscate="quantumObfuscate"
            >En mi domicilio</label
          >
        </div>
        <div class="descripcion" v-if="value === 'particular'">
          <p :data-obfuscate="quantumObfuscate">
            {{ particular.calle }} {{ particular.numero }}
          </p>
          <p :data-obfuscate="quantumObfuscate">
            {{ particular.piso }} {{ particular.dpto }} -
            {{ particular.codigoPostal }}
            {{ particular.localidad }}
          </p>
          <p :data-obfuscate="quantumObfuscate">
            {{ provinciaFormat.label }}, Argentina
          </p>
          <custom-link
            label="Modificar"
            @click.native="modificarDomicilio()"
            analyticsName="modificar domicilio"
          />
        </div>
      </div>
      <div class="item col2">
        <div class="input-container">
          <input
            type="radio"
            :name="'option-' + $parent._uid"
            :id="'option-otro-' + $parent._uid"
            value="otro"
            @input="$emit('input', $event.target.value)"
            @blur="onBlur('otro domicilio', 'otro')"
            :checked="otroDomicilio"
            :data-obfuscate="quantumObfuscate"
          />
          <label
            :for="'option-otro-' + $parent._uid"
            :data-obfuscate="quantumObfuscate"
            >Otro domicilio</label
          >
        </div>
        <div class="descripcion" v-if="value === 'otro'">
          <p :data-obfuscate="quantumObfuscate">
            {{ otro.calle }} {{ otro.numero }}
          </p>
          <p :data-obfuscate="quantumObfuscate">
            {{ otro.piso }} {{ otro.dpto }} -
            {{ otro.codigoPostal }}
            {{ otro.localidad }}
          </p>
          <p :data-obfuscate="quantumObfuscate">
            {{ provinciaFormatOtro.label }}, Argentina
          </p>
          <custom-link
            label="Modificar"
            @click.native="modificarDomicilio()"
            analyticsName="modificar domicilio"
          />
        </div>
      </div>
    </wrap-container>
    <change-address
      :show="showModal"
      @close="cerrarModal($event)"
      @aceptar="aceptar"
      v-model="direccion"
      :otroDomicilio="otroDomicilio"
      :quantumObfuscate="quantumObfuscate"
      :paquete="paquete"
    />
    <span class="error" v-if="error">
      <img src="@/assets/img/1x/error_icon.png" alt="Ícono error" />
      <p v-safe-html="error"></p>
    </span>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import ChangeAddress from "@/components/core/modals/ChangeAddress";
import CustomLink from "@/components/core/CustomLink";
import { byValue, provincias } from "@/config/constants";
import { get } from "../../../utils";
export default {
  name: "AddressSelector",
  data() {
    return {
      showModal: false,
      checked: false
    };
  },
  components: { WrapContainer, CustomLink, ChangeAddress },
  props: {
    value: String,
    particular: Object,
    otro: Object,
    quantumObfuscate: {
      type: Boolean,
      default: false
    },
    paquete: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    otroDomicilio() {
      return this.value === "otro";
    },
    provinciaFormat() {
      return byValue(this.particular.codProvincia, provincias);
    },
    provinciaFormatOtro() {
      return byValue(this.otro.codProvincia, provincias);
    },
    direccion() {
      if (this.otroDomicilio) {
        return this.otro;
      }
      return this.particular;
    },
    error() {
      if (!this.checkValid() && this.checked) {
        /** Indicamos si el domicilio inválido es el principal o el otro */
        let type = this.otroDomicilio ? "<strong>principal</strong>" : "";
        return `El domicilio ${type} no es válido`;
      }
      return null;
    }
  },
  methods: {
    agregarDomicilio() {
      this.showModal = true;
      document.getElementsByTagName("body")[0].classList.add("lock-scroll");
    },
    modificarDomicilio() {
      this.showModal = true;
      document.getElementsByTagName("body")[0].classList.add("lock-scroll");
    },
    cerrarModal(valid) {
      this.showModal = false;
      document.getElementsByTagName("body")[0].classList.remove("lock-scroll");
      document.getElementsByTagName("html")[0].classList.remove("lock-scroll");
      this.$emit("cerrar-modal", valid);
    },
    aceptar() {
      this.showModal = false;
      if (this.otroDomicilio && this.otro.valido) {
        document
          .getElementsByTagName("body")[0]
          .classList.remove("lock-scroll");
        this.showModal = false;
      } else if (!this.otroDomicilio && this.particular.valido) {
        this.showModal = false;
        document
          .getElementsByTagName("body")[0]
          .classList.remove("lock-scroll");
      }
    },
    onBlur(name, value) {
      this.$emit("onBlur", { name, value });
    },
    checkValid() {
      /**
       * Validacion para el form-validator para que no permita
       * avanzar con un domicilio inválido
       */
      this.checked = true;
      let valido = Boolean(Number(get(this.particular, "valido", null)));
      let calle = Boolean(get(this.particular, "calle", "").trim());
      let numero = Boolean(Number(get(this.particular, "numero", null)));
      const validoPrincipal = valido && calle && numero;
      let validoOtro = false;

      if (this.otroDomicilio) {
        let valido = Boolean(Number(get(this.otro, "valido", null)));
        let calle = Boolean(get(this.otro, "calle", "").trim());
        let numero = Boolean(Number(get(this.otro, "numero", null)));
        validoOtro = valido && calle && numero;
      } else {
        validoOtro = true;
      }

      return validoPrincipal && validoOtro;
    }
  }
};
</script>

<style scoped>
label.error {
  color: #b92a45;
}

span.error {
  margin-left: 16px;
  margin-bottom: 20px;
  margin-top: 8px;
  display: block;
}

span > img,
span > p {
  display: inline-block;
  vertical-align: top;
}

span > img {
  width: 16px;
}

span > p {
  margin-left: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #121212;
}

div.container {
  display: block;
  margin-bottom: 0px;
}

div.item {
  vertical-align: top;
  margin-bottom: 24px;
}

/* Estilos del detalle del domicilio particular */
div.descripcion {
  padding-top: 17px;
  padding-left: 45px;
  display: block;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: normal;
  color: #121212;
}

div.descripcion p {
  margin: 0;
  margin-bottom: 3px;
}

/* optional styles, I'm using this for centering radiobuttons */
.input-container {
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  display: inline-flex;
  align-items: center;
  width: 100%;
  height: 56px;
}

/* Estilo para errores */
div.container.error {
  background: #fcdfdf;
}

/* Estilos del radio */
/* https://stackoverflow.com/questions/26270168/how-to-customize-radio-button-in-html */
input[type="radio"] {
  /* remove standard background appearance */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* create custom radiobutton appearance */
  display: inline-block;
  width: 24px;
  height: 24px;
  padding: 5px;
  /* background-color only for content */
  background-clip: content-box;
  border: 1px solid #666666;
  background-color: white;
  border-radius: 50%;
  margin-top: 0px;
  margin-right: 8px;
  margin-left: 13px;
  cursor: pointer;
}

label {
  cursor: pointer;
  font-family: "BentonSansBBVA-Book", Helvetica, Arial, sans-serif;
}

/* appearance for checked radiobutton */
input[type="radio"]:checked {
  background-color: #004481;
}

input[type="radio"]:focus {
  outline: none;
}

input[type="radio"]:checked + label {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}
</style>
